<template src="./CreateOrderGHTKComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watch, watchEffect} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useStore} from "@/stores/store.js";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.js";
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import ModalCalendarComponent from "@/components/modals/modal-calendar/ModalCalendarComponent.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import {useGHTKStore} from "@/stores/syncGHTK.js";
import ErrorMessageService from "@/services/error-message.service.js";
import {useRoute, useRouter} from "vue-router";
import {usePartnerStore} from "@/stores/partner.js";
import {useDeliveryStore} from "@/stores/delivery.js";
import {useVietnamAdminData} from "@/composable/useVietnamAdminData.ts";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import InputNumberComponent from "@/components/inputs/input-number/InputNumberComponent.vue";
import dayjs from "dayjs";
import IconTrash from "@/components/icons/IconTrash.vue";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
export default {
  name: 'CreateOrderGHTKComponent',
  components: {
    LoadingComponent,
    IconTrash,
    InputNumberComponent,
    InputCheckboxOne,
    SelectCustom,
    ModalCalendarComponent,
    InputDateTimeNormal,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    VueDatePicker,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome, Multiselect
  },
  setup() {
    const errors = ref(true)
    const isLoading = ref(false)
    const errorMessage = ref([])
    const mode = ref('create')
    const labelButtonSetting = ref('Xác thực liên kết')
    const shipping_fee = ref(0)
    const dataCreateOrder = ref({
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        disabled: false,
        validations: ['required']
      },
      partner: {
        id: 'partner',
        label: 'Đối tác',
        placeholder: 'Đối tác',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
        options: [],
        validations: ['required']
      },
      delivery: {
        id: 'delivery',
        label: 'Dữ liệu giao hàng',
        placeholder: 'Dữ liệu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
        options: [],
        validations: ['required']
      },
      user_pickup: {
        id: 'user_pickup',
        label: 'Tên người liên hệ',
        placeholder: 'Tên người liên hệ',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
        validations: ['required']
      },
      pick_money: {
        id: 'pick_money',
        label: 'Số tiền CoD',
        placeholder: 'Số tiền CoD',
        value: 0,
        error: '',
        isError: false,
        required: true,
        disabled: false,
        validations: ['required']
      },
      pick_addr: {
        id: 'pick_addr',
        label: 'Địa chỉ chi tiết',
        placeholder: 'Địa chỉ chi tiết',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      pick_province: {
        id: 'pick_province',
        label: 'Tên tỉnh/thành phố',
        placeholder: 'Tên tỉnh/thành phố',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required']
      },
      pick_district: {
        id: 'pick_district',
        label: 'Tên quận/huyện',
        placeholder: 'Tên quận/huyện',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [],
        validations: ['required']
      },
      pick_ward: {
        id: 'pick_ward',
        label: 'Tên phường/xã',
        placeholder: 'Tên phường/xã',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required']
      },
      pick_street: {
        id: 'pick_street',
        label: 'Tên đường/phố',
        placeholder: 'Tên đường/phố',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: [['maxLength', 254]]
      },
      pick_tel: {
        id: 'pick_tel',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      pick_email: {
        id: 'pick_email',
        label: 'Email',
        placeholder: 'Email',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: ['email', ['maxLength', 254]]
      },
      receiver: {
        id: 'receiver',
        label: 'Người nhận hàng',
        placeholder: 'Người nhận hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      receiver_addr: {
        id: 'receiver_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      receiver_province: {
        id: 'receiver_province',
        label: 'Tên tỉnh/thành phố',
        placeholder: 'Tên tỉnh/thành phố',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required']
      },
      receiver_district: {
        id: 'receiver_district',
        label: 'Tên quận/huyện',
        placeholder: 'Tên quận/huyện',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [],
        validations: ['required']
      },
      receiver_ward: {
        id: 'receiver_ward',
        label: 'Tên phường/xã',
        placeholder: 'Tên phường/xã',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required']
      },
      receiver_street: {
        id: 'receiver_street',
        label: 'Tên đường/phố',
        placeholder: 'Tên đường/phố',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: [['maxLength', 254]]
      },
      receiver_hamlet: {
        id: 'receiver_hamlet',
        label: 'Tên thôn/ấp/xóm/tổ/...',
        placeholder: 'Tên thôn/ấp/xóm/tổ/...',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: [['maxLength', 254]]
      },
      receiver_tel: {
        id: 'receiver_tel',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      receiver_email: {
        id: 'receiver_email',
        label: 'Email',
        placeholder: 'Email',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: ['email', ['maxLength', 254]]
      },
      return_use_pick: {
        id: 'return_use_pick',
        label: 'Sử dụng thông tin lấy hàng',
        placeholder: 'Sử dụng thông tin lấy hàng',
        value: false,
        error: '',
        isError: false,
        required: true,
        validations: []
      },
      return_name: {
        id: 'return_name',
        label: 'Tên người nhận trả hàng',
        placeholder: 'Tên người nhận trả hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      return_address: {
        id: 'return_address',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      return_province: {
        id: 'return_province',
        label: 'Tên tỉnh/thành phố',
        placeholder: 'Tên tỉnh/thành phố',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required']
      },
      return_district: {
        id: 'return_district',
        label: 'Tên quận/huyện',
        placeholder: 'Tên quận/huyện',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [],
        validations: ['required']
      },
      return_ward: {
        id: 'return_ward',
        label: 'Tên phường/xã',
        placeholder: 'Tên phường/xã',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required']
      },
      return_street: {
        id: 'return_street',
        label: 'Tên đường/phố',
        placeholder: 'Tên đường/phố',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: [['maxLength', 254]]
      },
      return_tel: {
        id: 'return_tel',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      return_email: {
        id: 'return_email',
        label: 'Email',
        placeholder: 'Email',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: ['email', ['maxLength', 254]]
      },
      declared_value: {
        id: 'declared_value',
        label: 'Giá trị đóng khai giá',
        placeholder: 'Giá trị đóng khai giá',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required']
      },
      is_freeship: {
        id: 'is_freeship',
        label: 'Người trả phí ship',
        placeholder: 'Người trả phí ship',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [
          {
            value: 0,
            name: 'Người nhận hàng trả ship'
          },
          {
            value: 1,
            name: 'Người đưa hàng trả ship'
          }
        ],
        validations: []
      },
      total_weight: {
        id: 'total_weight',
        label: 'Tổng khối lượng đơn hàng',
        placeholder: 'Tổng khối lượng đơn hàng',
        value: 0,
        error: '',
        isError: false,
        required: false,
        validations: []
      },
      pick_date: {
        id: 'pick_date',
        label: 'Ngày lấy hàng mong muốn',
        placeholder: 'Ngày lấy hàng mong muốn',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: ['date']
      },
      deliver_date: {
        id: 'deliver_date',
        label: 'Ngày giao hàng mong muốn',
        placeholder: 'Ngày giao hàng mong muốn',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: ['date']
      },
      total_box: {
        id: 'total_box',
        label: 'Tổng số lượng kiện hàng',
        placeholder: 'Tổng số lượng kiện hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: []
      },
      pick_work_shift: {
        id: 'pick_work_shift',
        label: 'Ca lấy hàng mong muốn',
        placeholder: 'Ca lấy hàng mong muốn',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [
          {
            value: 1,
            name: 'Buổi sáng'
          },
          {
            value: 2,
            name: 'Buổi chiều'
          }
        ],
        validations: []
      },
      deliver_work_shift: {
        id: 'deliver_work_shift',
        label: 'Ca giao hàng mong muốn',
        placeholder: 'Ca giao hàng mong muốn',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [
          {
            value: 1,
            name: 'Buổi sáng'
          },
          {
            value: 2,
            name: 'Buổi chiều'
          }
        ],
        validations: []
      },
      note: {
        id: 'note',
        label: 'Ghi chú đơn hàng',
        placeholder: 'Ghi chú đơn hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        validations: []
      },
      transport: {
        id: 'transport',
        label: 'Phương thức vận chuyển',
        placeholder: 'Phương thức vận chuyển',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: [
          {
            name: 'Bộ',
            value: 1
          },
          {
            name: 'Bay',
            value: 2
          },
        ],
        validations: []
      },
      tags: {
        id: 'tags',
        label: 'Nhãn đơn hàng',
        placeholder: 'Nhãn đơn hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: AppConstant.GHTK_ORDER_TAGS,
        validations: []
      },
    })
    const dataHeaderTable = ref({
      product_name: {
        label: 'Tên sản phẩm',
        order: 1,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 2,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 3,
        width: '10%',
      },
      product_quantity: {
        label: 'Số lượng',
        order: 4,
        width: '10%',
      },
      product_weight: {
        label: 'Cân nặng (kg)',
        order: 5,
        width: '10%',
      },
      product_height: {
        label: 'Chiều cao (cm)',
        order: 6,
        width: '10%',
      },
      product_width: {
        label: 'Chiều rộng (cm)',
        order: 7,
        width: '10%',
      },
      product_length: {
        label: 'Chiều dài (cm)',
        order: 8,
        width: '10%',
      },
    })
    const listProductsSelected = ref([])
    const ghtkExpirationDateSelected = ref(null)
    const inputExpirationDate = ref(false)
    const date = ref(new Date())
    const showCalendar = ref(false)
    const accountStore = useAccountStore()
    const partnerStore = usePartnerStore()
    const deliveryStore = useDeliveryStore()
    const storeCompStore = useStore()
    const syncGHTKStore = useGHTKStore()
    const route = useRoute()
    const router = useRouter()
    const pickAdmin = useVietnamAdminData()
    const receiverAdmin = useVietnamAdminData()
    const returnAdmin = useVietnamAdminData()
    watch(() => ghtkExpirationDateSelected.value, (newValue) => {
      if (newValue) {
        inputExpirationDate.value = true
      }
    });

    watch(() => dataCreateOrder.value.partner.value, () => {
      getListDeliveries()
    });

    watch(() => dataCreateOrder.value.delivery.value, (newDelivery) => {
      getProductsDelivery(newDelivery)
    });

    watch(() => dataCreateOrder.value.pick_province.value, (newProvince) => {
      pickAdmin.getListDistricts(parseInt(newProvince))
    });

    watch(() => dataCreateOrder.value.receiver_province.value, (newProvince) => {
      receiverAdmin.getListDistricts(parseInt(newProvince))
    });

    watch(() => dataCreateOrder.value.return_province.value, (newProvince) => {
      returnAdmin.getListDistricts(parseInt(newProvince))
    });

    watch(() => dataCreateOrder.value.pick_district.value, (newDistrict) => {
      pickAdmin.getListWards(dataCreateOrder.value.pick_province.value, parseInt(newDistrict))
    });

    watch(() => dataCreateOrder.value.receiver_district.value, (newDistrict) => {
      receiverAdmin.getListWards(dataCreateOrder.value.receiver_province.value, parseInt(newDistrict))
    });

    watch(() => dataCreateOrder.value.return_district.value, (newDistrict) => {
      returnAdmin.getListWards(dataCreateOrder.value.return_province.value, parseInt(newDistrict))
    });
    watch(() => syncGHTKStore.shippingFee, (newShippingFee) => {
      shipping_fee.value = newShippingFee
    });

    watch(() => deliveryStore.deliveries, (newListDeliveries) => {
      newListDeliveries.forEach((delivery) => {
        dataCreateOrder.value.delivery.options.push({
          name: delivery.delivery_name,
          value: delivery.id,
          detail: delivery.m_delivery?.delivery_detail,
        })
      })
    });

    watch(() => deliveryStore.deliveryDetail, (newDeliveryDetail) => {
      listProductsSelected.value = newDeliveryDetail
      dataCreateOrder.value.declared_value.value = deliveryStore.totalPrice
    })

    watch(() => dataCreateOrder.value.return_use_pick.value, (newUsePick) => {
        dataCreateOrder.value.return_name.value = newUsePick ? dataCreateOrder.value.user_pickup.value : ''
        dataCreateOrder.value.return_tel.value = newUsePick ? dataCreateOrder.value.pick_tel.value : ''
        dataCreateOrder.value.return_email.value = newUsePick ? dataCreateOrder.value.pick_email.value : ''
        dataCreateOrder.value.return_address.value = newUsePick ? dataCreateOrder.value.pick_addr.value : ''
        dataCreateOrder.value.return_province.value = newUsePick ? dataCreateOrder.value.pick_province.value : ''
        dataCreateOrder.value.return_ward.value = newUsePick ? dataCreateOrder.value.pick_ward.value : ''
        dataCreateOrder.value.return_district.value = newUsePick ? dataCreateOrder.value.pick_district.value : ''
        dataCreateOrder.value.return_street.value = newUsePick ? dataCreateOrder.value.pick_street.value : ''
    })

    onMounted(() => {
      if (storeCompStore.stores.length === 0) {
        getListStores()
      } else {
        storeCompStore.stores.forEach((item) => {
          dataCreateOrder.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
      if (partnerStore.partners.length === 0) {
        getListPartner()
      } else {
        partnerStore.partners.forEach((item) => {
          dataCreateOrder.value.partner.options.push({
            name: item.partner_name,
            value: item.partner_company_id
          })
        })
      }
      pickAdmin.loadVietnamData()
      receiverAdmin.loadVietnamData()
      returnAdmin.loadVietnamData()
    });

    watchEffect(() => {
      if (pickAdmin.provinces.value.length > 0) {
        dataCreateOrder.value.pick_province.options = pickAdmin.provinces.value.map(p => ({
          name: p.name,
          value: p.code,
        }))
      }
      if (pickAdmin.districts.value.length > 0 && dataCreateOrder.value.pick_province.value) {
        dataCreateOrder.value.pick_district.options = pickAdmin.districts.value.map(d => ({
          name: d.name,
          value: d.code,
        }))
      }
      if (pickAdmin.wards.value.length > 0 && dataCreateOrder.value.pick_district.value) {
        dataCreateOrder.value.pick_ward.options = pickAdmin.wards.value.map(w => ({
          name: w.name,
          value: w.code,
        }))
      }

      if (receiverAdmin.provinces.value.length > 0) {
        dataCreateOrder.value.receiver_province.options = receiverAdmin.provinces.value.map(p => ({
          name: p.name,
          value: p.code,
        }))
      }
      if (receiverAdmin.districts.value.length > 0 && dataCreateOrder.value.receiver_province.value) {
        dataCreateOrder.value.receiver_district.options = receiverAdmin.districts.value.map(d => ({
          name: d.name,
          value: d.code,
        }))
      }
      if (receiverAdmin.wards.value.length > 0 && dataCreateOrder.value.receiver_district.value) {
        dataCreateOrder.value.receiver_ward.options = receiverAdmin.wards.value.map(w => ({
          name: w.name,
          value: w.code,
        }))
      }

      if (returnAdmin.provinces.value.length > 0) {
        dataCreateOrder.value.return_province.options = returnAdmin.provinces.value.map(p => ({
          name: p.name,
          value: p.code,
        }))
      }
      if (returnAdmin.districts.value.length > 0 && dataCreateOrder.value.return_province.value) {
        dataCreateOrder.value.return_district.options = returnAdmin.districts.value.map(d => ({
          name: d.name,
          value: d.code,
        }))
      }
      if (returnAdmin.wards.value.length > 0 && dataCreateOrder.value.return_district.value) {
        dataCreateOrder.value.return_ward.options = returnAdmin.wards.value.map(w => ({
          name: w.name,
          value: w.code,
        }))
      }
    })

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    async function getProductsDelivery(deliveryId) {
      const params = {
        id: accountStore.account.company.id,
        delivery_id: deliveryId
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/delivery-details/products';
      await deliveryStore.getProductsDelivery(url, params);
    }
    async function getListPartner() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/partner-list';
      await partnerStore.getListPartners(url, params);
      partnerStore.partners.forEach((partner) => {
        dataCreateOrder.value.partner.options.push({
          name: partner.partner_name,
          value: partner.partner_company_id
        })
      })
    }

    function getListDeliveries() {
      isLoading.value = true
      const params = {
        company_id: accountStore.account.company.id,
        partner_id: dataCreateOrder.value.partner.value,
        store_id: dataCreateOrder.value.store_id.value,
        status: 3
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/list-deliveries';
      deliveryStore.getListDeliveriesWithoutLimit(url, params);
    }

    function validateForm(value, name) {
      const field = dataCreateOrder.value[name]
      if (!field) return false

      let fieldHasError = false
      field.isError = false
      field.error = ''

      const rules = {
        required: (v) => !v && ErrorText.REQUIRED(field.label),
        maxLength: (v, max) => v && v.length > max && ErrorText.MAX_LENGTH(field.label, max),
        email: (v) => v && !CommonService.validateEmail(v) && ErrorMessageConstant.ERROR_MAIL_INVALID,
        phone: (v) => v && ![10, 11].includes(v.length) && ErrorMessageConstant.ERROR_PHONE_LENGTH,
        decimal: (v) => v && !CommonService.validateDecimal(v) && ErrorMessageConstant.ERROR_NUMBER_INVALID,
        date: (v) => v && !dayjs(v, 'DD-MM-YYYY', true).isValid() && ErrorText.INVALID(field.label),
      }

      const validations = Object.keys(dataCreateOrder.value).reduce((acc, key) => {
        const field = dataCreateOrder.value[key];
        if (Array.isArray(field.validations) && field.validations.length > 0) {
          acc[key] = field.validations;
        }
        return acc;
      }, {});

      const fieldRules = validations[name] || []
      for (const rule of fieldRules) {
        let errorMessage
        if (Array.isArray(rule)) {
          const [ruleName, param] = rule
          errorMessage = rules[ruleName]?.(value, param)
        } else {
          errorMessage = rules[rule]?.(value)
        }
        if (errorMessage) {
          field.isError = true
          field.error = errorMessage
          fieldHasError = true
          break
        }
      }

      if (name === 'receiver_street' && !value && !dataCreateOrder.value.receiver_hamlet.value) {
        field.isError = true
        dataCreateOrder.value.receiver_hamlet.isError = true
        field.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_hamlet.label)
        dataCreateOrder.value.receiver_hamlet.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_street.label)
        fieldHasError = true
      }

      if (name === 'receiver_hamlet' && !value && !dataCreateOrder.value.receiver_street.value) {
        field.isError = true
        dataCreateOrder.value.receiver_hamlet.isError = true
        field.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_street.label)
        dataCreateOrder.value.receiver_hamlet.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_hamlet.label)
        fieldHasError = true
      }

      if (name === 'pick_date' && value) {
        if (dayjs(value, 'DD-MM-YYYY').isBefore(dayjs())) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_DATE(field.label)
          fieldHasError = true
        }
        const deliver = dataCreateOrder.value.deliver_date.value
        if (!fieldHasError && deliver && dayjs(value, 'DD-MM-YYYY').isAfter(dayjs(deliver, 'DD-MM-YYYY'))) {
          field.isError = true
          field.error = ErrorText.NOT_AFTER_DATE(field.label)
          fieldHasError = true
        }
      }

      if (name === 'deliver_date' && value) {
        if (dayjs(value, 'DD-MM-YYYY').isBefore(dayjs())) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_NOW(field.label)
          fieldHasError = true
        }
        const pick = dataCreateOrder.value.pick_date.value
        if (!fieldHasError && pick && dayjs(value, 'DD-MM-YYYY').isAfter(dayjs(pick, 'DD-MM-YYYY'))) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_DATE(field.label)
          fieldHasError = true
        }
      }

      return fieldHasError
    }

    function onChange(value, name) {
      dataCreateOrder.value[name].value = value;
      if (value !== null && value !== undefined && value !== '') {
        dataCreateOrder.value[name].isError = false;
        dataCreateOrder.value[name].error = '';
        if(name === 'receiver_street' || name === 'receiver_hamlet' ) {
          dataCreateOrder.value.receiver_hamlet.isError = false;
          dataCreateOrder.value.receiver_hamlet.error = '';
          dataCreateOrder.value.receiver_street.isError = false;
          dataCreateOrder.value.receiver_street.error = '';
        }
      }
    }
    function redirectToList() {
      router.push('/third-party/ghtk')
    }

    watch(
        [
          () => dataCreateOrder.value.pick_province.value,
          () => dataCreateOrder.value.pick_ward.value,
          () => dataCreateOrder.value.pick_district.value,
          () => dataCreateOrder.value.receiver_province.value,
          () => dataCreateOrder.value.receiver_ward.value,
          () => dataCreateOrder.value.receiver_district.value,
          () => dataCreateOrder.value.transport.value,
          () => dataCreateOrder.value.tags.value,
        ],
        ([w, d, s, c, tr, ta]) => {
          if ([w, d, s, c, tr, ta].every(v => v !== '' && v !== null && v !== undefined)) {
            getShippingFee()
          } else {
            shipping_fee.value = 0
          }
        }
    )

    async function getShippingFee() {
      syncGHTKStore.shippingFee = 0;
      const totalWeight = listProductsSelected.value.reduce((sum, item) => {
        return sum + (Number(item.product?.weight) || 0)
      }, 0)
      const params = {
        company_id: accountStore.account.company.id,
        store_id: dataCreateOrder.value.store_id.value,
        pick_province: pickAdmin.provinces.value.find(
            item => item.code === dataCreateOrder.value.pick_province.value
        )?.name,
        pick_district: pickAdmin.districts.value.find(
          item => item.code === dataCreateOrder.value.pick_district.value
        )?.name,
        pick_ward: pickAdmin.wards.value.find(
            item => item.code === dataCreateOrder.value.pick_ward.value
        )?.name,
        pick_address: dataCreateOrder.value.pick_addr.value,
        pick_street: dataCreateOrder.value.pick_street.value,
        province: receiverAdmin.provinces.value.find(
            item => item.code === dataCreateOrder.value.receiver_province.value
        )?.name,
        district: receiverAdmin.districts.value.find(
            item => item.code === dataCreateOrder.value.receiver_district.value
        )?.name,
        ward: receiverAdmin.wards.value.find(
            item => item.code === dataCreateOrder.value.receiver_ward.value
        )?.name,
        weight: totalWeight,
        transport: dataCreateOrder.value.receiver_ward.value,
        tags: dataCreateOrder.value.tags.value ? dataCreateOrder.value.tags.value.map(tag => tag.value) : '',
        address: dataCreateOrder.value.receiver_addr.value,
        street: dataCreateOrder.value.receiver_street.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/shipping-fee';
      await syncGHTKStore.getShippingFee(url, params)
    }

    function validateOrderField(value, name) {
      let hasError = CommonService.validateForm(value, name, dataCreateOrder)

      const field = dataCreateOrder.value[name]
      if (!field) return hasError

      if (name === 'receiver_street' && !value && !dataCreateOrder.value.receiver_hamlet.value) {
        field.isError = true
        field.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_hamlet.label)
        hasError = true
      }

      if (name === 'receiver_hamlet' && !value && !dataCreateOrder.value.receiver_street.value) {
        field.isError = true
        field.error = ErrorText.REQUIRED_WHEN_OTHER_EMPTY(field.label, dataCreateOrder.value.receiver_street.label)
        hasError = true
      }

      if (name === 'pick_date' && value) {
        if (dayjs(value, 'DD-MM-YYYY').isBefore(dayjs(), 'day')) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_DATE(field.label)
          hasError = true
        }
      }

      if (name === 'deliver_date' && value) {
        const pickDate = dataCreateOrder.value.pick_date.value
        if (dayjs(value, 'DD-MM-YYYY').isBefore(dayjs(), 'day')) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_NOW(field.label)
          hasError = true
        }
        if (pickDate && dayjs(value, 'DD-MM-YYYY').isBefore(dayjs(pickDate, 'DD-MM-YYYY'))) {
          field.isError = true
          field.error = ErrorText.NOT_BEFORE_DATE(field.label)
          hasError = true
        }
      }

      return hasError
    }

    async function createOrderGHTK() {
      errors.value = false
      for (const key in dataCreateOrder.value) {
        const hasError = validateOrderField(dataCreateOrder.value[key].value, key)
        if (hasError) errors.value = true
      }
      if(!errors.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          store_id: dataCreateOrder.value.store_id.value,
          delivery_id: dataCreateOrder.value.delivery.value,
          third_party_id: 1,
          products: listProductsSelected.value.map(item => ({
            name: item.product_name,
            product_code: "",
            quantity: item.product_quantity,
            price: item.product_price,
            weight: item.product?.weight || 0,
            height: item.product?.height || '',
            width: item.product?.width || '',
            length: item.product?.length || '',
          })),
          order: {
            pick_name: dataCreateOrder.value.user_pickup.value,
            pick_money: dataCreateOrder.value.pick_money.value,
            pick_address: dataCreateOrder.value.pick_addr.value,
            pick_province: {
              name: pickAdmin.provinces.value.find(
                  item => item.code === dataCreateOrder.value.pick_province.value
              )?.name,
              value: dataCreateOrder.value.pick_province.value
            },
            pick_district: {
              name: pickAdmin.districts.value.find(
                  item => item.code === dataCreateOrder.value.pick_district.value
              )?.name,
              value: dataCreateOrder.value.pick_district.value
            },
            pick_ward: {
              name: pickAdmin.wards.value.find(
                  item => item.code === dataCreateOrder.value.pick_ward.value
              )?.name,
              value: dataCreateOrder.value.pick_ward.value
            },
            pick_street: dataCreateOrder.value.pick_street.value,
            pick_tel: dataCreateOrder.value.pick_tel.value,
            pick_email: dataCreateOrder.value.pick_email.value,
            receiver_name: dataCreateOrder.value.receiver.value,
            receiver_address: dataCreateOrder.value.receiver_addr.value,
            receiver_province: {
              name: receiverAdmin.provinces.value.find(
                  item => item.code === dataCreateOrder.value.receiver_province.value
              )?.name,
              value: dataCreateOrder.value.receiver_province.value
            },
            receiver_district: {
              name: receiverAdmin.districts.value.find(
                  item => item.code === dataCreateOrder.value.receiver_district.value
              )?.name,
              value: dataCreateOrder.value.receiver_district.value
            },
            receiver_ward: {
              name: receiverAdmin.wards.value.find(
                  item => item.code === dataCreateOrder.value.receiver_ward.value
              )?.name,
              value: dataCreateOrder.value.receiver_ward.value
            },
            receiver_street: dataCreateOrder.value.receiver_street.value,
            receiver_hamlet: dataCreateOrder.value.receiver_hamlet.value,
            receiver_tel: dataCreateOrder.value.receiver_tel.value,
            receiver_email: dataCreateOrder.value.receiver_email.value,
            note: dataCreateOrder.value.note.value,
            return_name: dataCreateOrder.value.return_name.value,
            return_address: dataCreateOrder.value.return_address.value,
            return_province: {
              name: returnAdmin.provinces.value.find(
                  item => item.code === dataCreateOrder.value.return_province.value
              )?.name,
              value: dataCreateOrder.value.return_province.value
            },
            return_district: {
              name: returnAdmin.districts.value.find(
                  item => item.code === dataCreateOrder.value.return_district.value
              )?.name,
              value: dataCreateOrder.value.return_district.value
            },
            return_ward: {
              name: returnAdmin.wards.value.find(
                  item => item.code === dataCreateOrder.value.return_ward.value
              )?.name,
              value: dataCreateOrder.value.return_ward.value
            },
            return_street: dataCreateOrder.value.return_street.value,
            return_tel: dataCreateOrder.value.return_tel.value,
            return_email: dataCreateOrder.value.return_email.value,
            is_freeship: dataCreateOrder.value.is_freeship.value || 0,
            total_weight: dataCreateOrder.value.total_weight.value || 0,
            pick_work_shift: dataCreateOrder.value.pick_work_shift.value || 0,
            deliver_work_shift: dataCreateOrder.value.deliver_work_shift.value  || 0,
            pick_date: dataCreateOrder.value.pick_date.value,
            declared_value: dataCreateOrder.value.declared_value.value,
            shipping_fee: shipping_fee.value || 0,
            transport: dataCreateOrder.value.transport.value || 0,
            tags: dataCreateOrder.value.tags.value ? dataCreateOrder.value.tags.value.map(tag => tag.value) : null,
            total_box: dataCreateOrder.value.total_box.value || 0,
          }
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/order/create';
        const res = await syncGHTKStore.createOrderThirdParty(url, params);
        const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
        if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
          errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
        } else {
          await CommonService.showAlertPopup({
            title: res?.message,
            icon: res?.status,
            showConfirmButton: false,
            timer: 1200,
            width: '800px'
          });
          await router.push('/third-party/ghtk/order')
        }
      }
    }
    return {
      mode,
      labelButtonSetting,
      dataCreateOrder,
      date,
      showCalendar,
      ghtkExpirationDateSelected,
      inputExpirationDate,
      dataHeaderTable,
      listProductsSelected,
      shipping_fee,
      createOrderGHTK,
      redirectToList,
      CommonService,
      errors,
      onChange,
      validateForm,
      errorMessage,
      syncGHTKStore,
      isLoading
    }
  }
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        #expiration_date {
          option {
            &:nth-child(8) {
              display: none;
            }
          }
        }
        .order-value,
        .shipping-fee {
          font-weight: 600;
          font-size: 16px;
          padding: 6px 12px;
          border-radius: 8px;
          display: inline-block;
          border: 1px solid #ffe082;
          background-color: #fff8e1;
          transition: all 0.3s ease;
        }
        .order-value:hover,
        .shipping-fee:hover {
          transform: scale(1.05);
          background-color: #ffecb3;
        }
        .order-value {
          color: #1565c0;
        }
        .shipping-fee {
          color: #d32f2f;
        }
        .shipping-fee::after {
          content: attr(data-tooltip);
          position: absolute;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          background-color: #333;
          color: #fff;
          font-size: 13px;
          padding: 6px 10px;
          border-radius: 6px;
          white-space: nowrap;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease, transform 0.3s ease;
          z-index: 100;
        }
        .shipping-fee:hover::after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
